<template>
  <VDialog v-model="isOpen" :title="title" class="booking-amended-confirm" dialog-classes="booking-amended-confirm__dialog">
      <div class="booking-amended-confirm">
        <p v-if="text" class="booking-amended-confirm__text">
          {{ text }}
        </p>
        <div class="booking-amended-confirm__footer">
          <VButton orange-outline class="booking-amended-confirm__button" @click="cancel">
            {{ cancelText }}
          </VButton>

          <VButton base class="booking-amended-confirm__button" @click="confirm">
            {{ confirmText }}
          </VButton>
        </div>
      </div>
  </VDialog>
</template>

<script>
import VButton from '@/components/controls/VButton.vue'
import VDialog from '@/components/common/VDialog.vue'

export default {
  name: 'BookingAmendedConfirm',
  components: { VButton, VDialog },

  props: {
    title: { type: String, required: true },
    text: { type: String, default: '' },
    cancelText: { type: String, default: 'No' },
    confirmText: { type: String, default: 'Yes' },
  },

  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    open() {
      return new Promise((resolve, reject) => {
        if (this.$options.reject) {
          this.$options.reject()
          this.cancelPromise()
        }

        this.$options.resolve = resolve
        this.$options.reject = reject

        this.isOpen = true
      })
    },

    confirm() {
      this.closeAndResolveValue(true)
    },

    cancel() {
      this.closeAndResolveValue(false)
    },
    closeAndResolveValue(value) {
      this.$options.resolve(value)
      this.cancelPromise()

      this.isOpen = false
    },

    cancelPromise() {
      this.$options.resolve = null
      this.$options.reject = null
    }
  },
  resolve: null,
  reject: null
}
</script>
<style lang="scss">
.booking-amended-confirm {
  background-color: #fff;
  border-radius: 12px;
  max-width: 550px;

  &__dialog {
    .v-dialog__title {
      font-weight: 600;
    }
  }

  &__text {
    margin-top: 30px;
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
    color: $text-primary;
    margin-bottom: 34px;
  }

  &__footer {
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }

  &__button {
    flex-grow: 1;
    height: 49px;
  }
}
</style>
